export function showWarning(name: string, id?: number) {
  if (id) {
    if (
      window.myGlobalVar.pendingChanges &&
      window.myGlobalVar.pendingChanges.status &&
      window.myGlobalVar.pendingChanges.showWarning &&
      window.myGlobalVar.pendingChanges.items.indexOf(
        `${name + "(" + id + ")"}`
      ) >= 0
    )
      return true;
    else return false;
  } else {
    if (
      window.myGlobalVar.pendingChanges &&
      window.myGlobalVar.pendingChanges.status &&
      window.myGlobalVar.pendingChanges.showWarning &&
      window.myGlobalVar.pendingChanges.items.indexOf(`${name}`) >= 0
    )
      return true;
    else return false;
  }
}
